export default __webpack_public_path__ + "static/media/belt.0c738800.png";